<div id="quotation__quote-form" class="quote-form card">
  <form [formGroup]="quoteForm">
    <div class="row non-input-box-height">
      <div class="col-12 col-sm-12 col-md-12 col-lg-6">
        <div class="row">
          <div class="col-12 col-sm-12 col-md-4 col-lg-5">
            <span class="font-weight-bold"
              >{{ 'type' | translate }}
              <span class="text-danger">* </span>
              <i
                aria-hidden="true"
                class="fa fa-question-circle"
                containerClass="family-tooltip"
                [tooltip]="'familyTooltip' | translate"
                placement="right"
              ></i>
            </span>
          </div>
          <div class="col-12 col-sm-12 col-md-6 col-lg-6">
            <ng-select
              [items]="typeList"
              [placeholder]="'selectOption' | translate"
              [clearable]="false"
              formControlName="type"
              (change)="onChangeType()"
              name="type"
              data-testId="type"
            >
              <ng-template ng-label-tmp ng-option-tmp let-item="item">
                {{ item | masterDataTranslate | async }}
              </ng-template>
            </ng-select>
          </div>
        </div>
      </div>
    </div>
    <div class="row mt-3 non-input-box-height">
      <div class="col-12 col-sm-12 col-md-12 col-lg-11">
        <div class="row">
          <div class="col-12 col-sm-12 col-md-4 col-lg-3">
            <span class="font-weight-bold">{{ 'channel' | translate }} <span class="text-danger">*</span></span>
          </div>
          <div class="col-12 col-sm-12 col-md-7 col-lg-9 radio-padding">
            <div class="form-check form-check-inline">
              <label class="form-check-label radio" for="channelType1" [ngClass]="{ disabled: channelType.disabled }"
                >{{ 'direct' | translate }}
                <input
                  class="form-check-input form-set-inline"
                  formControlName="channelType"
                  type="radio"
                  name="channelType"
                  [value]="channel.DIRECT"
                  id="channelType1"
                  (change)="onChangeChannelType()"
                  data-testId="direct"
                /><span class="checkround"></span>
              </label>
            </div>
            <div class="form-check form-check-inline form-set-inline">
              <label class="radio"
                >{{ 'intermediary' | translate }}
                <input
                  class="form-check-input"
                  formControlName="channelType"
                  type="radio"
                  name="channelType"
                  [value]="channel.INTERMEDIARY"
                  id="channelType2"
                  (change)="onChangeChannelType()"
                  data-testId="intermediary"
                />
                <span class="checkround"></span>
              </label>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="row mt-2" *ngIf="!isDirectChannel()">
      <div class="col-12 col-sm-12 col-md-12 col-lg-6">
        <div class="row">
          <div class="col-12 col-sm-12 col-md-4 col-lg-5">
            <span class="font-weight-bold">{{ 'imdCode&Name' | translate }} <span class="text-danger">*</span></span>
          </div>
          <div class="col-12 col-sm-12 col-md-6 col-lg-6">
            <ng-select
              [items]="imdCodeList"
              bindLabel="intermediaryDesc"
              [placeholder]="'selectOption' | translate"
              [virtualScroll]="true"
              formControlName="imdCode"
              name="imdCode"
              (change)="onChangeImdCode()"
              data-testId="imdCode"
            >
            </ng-select>
          </div>
        </div>
      </div>
      <div class="col-12 col-sm-12 col-md-12 col-lg-6">
        <div class="row">
          <div class="col-12 col-sm-12 col-md-4 col-lg-5 offset-lg-1">
            <span class="font-weight-bold">{{ 'aoMember' | translate }}</span>
          </div>
          <div class="col-12 col-sm-12 col-md-6 col-lg-6">
            <ng-select
              [items]="aoMemberList"
              [searchable]="false"
              bindLabel="memberName"
              [placeholder]="'selectOption' | translate"
              [clearable]="false"
              formControlName="aoMember"
              name="aoMember"
              data-testId="aoMember"
            >
            </ng-select>
          </div>
        </div>
      </div>
    </div>
    <div class="row" [class.mt-3]="!isDirectChannel()">
      <div class="col-12 col-sm-12 col-md-12 col-lg-6">
        <div class="row">
          <div class="col-12 col-sm-12 col-md-4 col-lg-5">
            <span class="font-weight-bold">{{ 'insuranceType' | translate }} <span class="text-danger">*</span></span>
          </div>
          <div class="col-12 col-sm-12 col-md-6 col-lg-6">
            <ng-select
              [items]="insuranceTypeList"
              [searchable]="false"
              bindLabel="description"
              [placeholder]="'selectOption' | translate"
              [clearable]="false"
              formControlName="insuranceType"
              name="insuranceType"
              (change)="onChangeInsuranceType()"
              data-testId="insuranceType"
            >
            </ng-select>
          </div>
        </div>
      </div>
      <div class="col-12 col-sm-12 col-md-12 col-lg-6">
        <div class="row">
          <div class="col-12 col-sm-12 col-md-4 col-lg-5 offset-lg-1">
            <span class="font-weight-bold">{{ 'insurancePlan' | translate }} <span class="text-danger">*</span></span>
          </div>
          <div class="col-12 col-sm-12 col-md-6 col-lg-6">
            <ng-select
              [items]="insurancePlanList"
              [searchable]="false"
              bindLabel="topLevelDesc"
              [placeholder]="'selectOption' | translate"
              [clearable]="false"
              (change)="onChangeInsurancePlan()"
              formControlName="insurancePlan"
              name="insurancePlan"
              data-testId="insurancePlan"
            >
            </ng-select>
          </div>
        </div>
      </div>
    </div>
    <div class="row mt-3" *ngIf="isStudentOverseaPlan()">
      <div class="col-12 col-sm-12 col-md-12 col-lg-6">
        <div class="row">
          <div class="col-12 col-sm-12 col-md-4 col-lg-5">
            <span class="font-weight-bold">{{ 'period' | translate }} <span class="text-danger">*</span></span>
          </div>
          <div class="col-12 col-sm-12 col-md-6 col-lg-6">
            <ng-select
              [items]="periodList"
              [placeholder]="'selectOption' | translate"
              [clearable]="false"
              (change)="onChangePeriod()"
              formControlName="period"
              name="period"
              data-testId="period"
            >
              <ng-template ng-label-tmp ng-option-tmp let-item="item"> {{ item.code }} {{ 'day(s)' | translate }} </ng-template>
            </ng-select>
          </div>
        </div>
      </div>
      <div class="col-12 col-sm-12 col-md-12 col-lg-6">
        <div class="row">
          <div class="col-12 col-sm-12 col-md-4 col-lg-5 offset-lg-1">
            <span class="font-weight-bold">{{ 'schoolName' | translate }} <span class="text-danger">*</span></span>
          </div>
          <div class="col-12 col-sm-12 col-md-6 col-lg-6">
            <input
              id="schoolName"
              name="schoolName"
              class="form-control"
              type="text"
              autocomplete="off"
              formControlName="schoolName"
              data-testId="schoolName"
            />
          </div>
        </div>
      </div>
    </div>
    <div class="row mt-3 non-input-box-height" *ngIf="!isStudentOverseaPlan()">
      <div class="col-12 col-sm-12 col-md-12 col-lg-6">
        <div class="row">
          <div class="col-12 col-sm-12 col-md-4 col-lg-5">
            <span class="font-weight-bold">{{ 'typeOfTravel' | translate }} <span class="text-danger">*</span></span>
          </div>
          <div class="col-12 col-sm-12 col-md-6 col-lg-6 radio-display">
            <div class="form-check">
              <label class="form-check-label radio" for="travelType1"
                >{{ 'singleTrip' | translate }}
                <input
                  class="form-check-input"
                  formControlName="travelType"
                  type="radio"
                  name="travelType"
                  [value]="typeofTravel.SINGLE_TRIP"
                  id="travelType1"
                  (ngModelChange)="onChangeTravelType()"
                  data-testId="singleTrip"
                /><span class="checkround"></span>
              </label>
            </div>
            <div class="form-check">
              <label class="form-check-label radio" for="travelType2" [ngClass]="{ disabled: travelType.disabled }"
                >{{ 'annualTrip' | translate }}
                <input
                  class="form-check-input"
                  formControlName="travelType"
                  type="radio"
                  name="travelType"
                  [value]="typeofTravel.ANNUAL_TRIP"
                  id="travelType2"
                  (ngModelChange)="onChangeTravelType()"
                  data-testId="annualTrip"
                /><span class="checkround"></span>
              </label>
            </div>
          </div>
        </div>
      </div>
      <div class="col-12 col-sm-12 col-md-12 col-lg-6" *ngIf="isAnnualTrip()">
        <div class="row">
          <div class="col-12 col-sm-12 col-md-4 col-lg-5 offset-lg-1">
            <span class="font-weight-bold">{{ 'period' | translate }} <span class="text-danger">*</span></span>
          </div>
          <div class="col-12 col-sm-12 col-md-6 col-lg-6">
            <ng-select
              [items]="durationPeriodList"
              [placeholder]="'selectOption' | translate"
              [clearable]="false"
              formControlName="durationPeriod"
              name="durationPeriod"
              data-testId="durationPeriod"
            >
              <ng-template ng-label-tmp ng-option-tmp let-item="item"> {{ item.code }} {{ 'day(s)' | translate }} </ng-template>
            </ng-select>
          </div>
        </div>
      </div>
    </div>
    <div class="row mt-3">
      <div class="col-12 col-sm-12 col-md-12 col-lg-6">
        <div class="row">
          <div class="col-12 col-sm-12 col-md-4 col-lg-5">
            <span class="font-weight-bold">{{ 'from' | translate }} <span class="text-danger">*</span></span>
          </div>
          <div class="col-12 col-sm-12 col-md-6 col-lg-6">
            <ng-select
              [items]="departure$ | async"
              [placeholder]="'selectOption' | translate"
              formControlName="from"
              name="fromCountry"
              [searchable]="true"
              [searchFn]="search"
              [virtualScroll]="true"
              data-testId="fromCountry"
            >
              <ng-template ng-label-tmp ng-option-tmp let-item="item">
                {{ item | masterDataTranslate | async }}
              </ng-template>
            </ng-select>
          </div>
        </div>
      </div>
      <div class="col-12 col-sm-12 col-md-12 col-lg-6">
        <div class="row">
          <div class="col-12 col-sm-12 col-md-4 col-lg-5 offset-lg-1">
            <span class="font-weight-bold"
              >{{ 'to' | translate }}<span class="text-danger ml-1 mr-1">*</span
              ><i
                aria-hidden="true"
                class="fa fa-question-circle"
                containerClass="to-country-tooltip"
                [tooltip]="'toCountryTooltip' | translate"
                placement="right"
              ></i
            ></span>
          </div>
          <div class="col-12 col-sm-12 col-md-6 col-lg-6">
            <ng-select
              [items]="destination$ | async"
              [multiple]="true"
              [placeholder]="'selectOption' | translate"
              formControlName="to"
              maxSelectedItems="{{ maxSelectedCountry }}"
              name="toCountry"
              [searchable]="true"
              [searchFn]="search"
              [virtualScroll]="true"
              data-testId="toCountry"
            >
              <ng-template ng-label-tmp ng-option-tmp let-item="item">
                {{ item | masterDataTranslate | async }}
              </ng-template>
            </ng-select>
          </div>
        </div>
      </div>
    </div>
    <div class="row mt-3">
      <div class="col-12 col-sm-12 col-md-12 col-lg-6">
        <div class="row">
          <div class="col-12 col-sm-12 col-md-4 col-lg-5">
            <span class="font-weight-bold">{{ 'fromDate' | translate }} <span class="text-danger">*</span></span>
          </div>
          <div class="col-12 col-sm-12 col-md-6 col-lg-6">
            <div class="input-group">
              <input
                class="form-control date-input"
                placeholder="dd-mm-yyyy"
                name="fromDate"
                formControlName="fromDate"
                ngbDatepicker
                #fromDate="ngbDatepicker"
                (click)="fromDate.toggle(); $event.stopPropagation()"
                (ngModelChange)="onChangeFromDate()"
                [minDate]="minFromDate"
                [maxDate]="toDate?.value"
                readonly
                data-testId="fromDate"
              />
              <div class="input-group-append input-with-inline button-width" (click)="fromDate.toggle(); $event.stopPropagation()">
                <span class="glyphicon glyphicon-calendar"><i class="fa fa-calendar" aria-hidden="true"></i></span>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="col-12 col-sm-12 col-md-12 col-lg-6">
        <div class="row">
          <div class="col-12 col-sm-12 col-md-4 col-lg-5 offset-lg-1">
            <span class="font-weight-bold">{{ 'toDate' | translate }} <span class="text-danger">*</span></span>
          </div>
          <div class="col-12 col-sm-12 col-md-6 col-lg-6">
            <div class="input-group">
              <input
                class="form-control date-input"
                placeholder="dd-mm-yyyy"
                name="toDate"
                formControlName="toDate"
                ngbDatepicker
                #toDate="ngbDatepicker"
                (click)="toDate.toggle(); $event.stopPropagation()"
                (ngModelChange)="onChangeToDate()"
                [minDate]="minToDate"
                [maxDate]="maxToDate"
                readonly
                [ngClass]="{ 'ng-invalid invalid': toDate.invalid }"
                data-testId="toDate"
              />
              <div
                class="input-group-append input-with-inline button-width"
                [ngClass]="{ 'bg-disabled': toDate.disabled }"
                (click)="!toDate.disabled && toDate.toggle(); $event.stopPropagation()"
              >
                <span class="glyphicon glyphicon-calendar"><i class="fa fa-calendar" aria-hidden="true"></i></span>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="row mt-3">
      <div class="col-12 col-sm-12 col-md-12 col-lg-6">
        <div class="row">
          <div class="col-12 col-sm-12 col-md-4 col-lg-5">
            <span class="font-weight-bold">{{ 'noOfPersons' | translate }} <span class="text-danger">*</span></span>
          </div>
          <div class="col-12 col-sm-12 col-md-6 col-lg-6">
            <ng-select
              [items]="numPeopleList"
              bindLabel="code"
              [placeholder]="'selectOption' | translate"
              [clearable]="false"
              formControlName="numPeople"
              name="numPeople"
              data-testId="numPeople"
            >
            </ng-select>
          </div>
        </div>
      </div>
      <div class="col-12 col-sm-12 col-md-12 col-lg-6">
        <div class="row">
          <div class="col-12 col-sm-12 col-md-4 col-lg-5 offset-lg-1">
            <span class="font-weight-bold">{{ 'duration' | translate }} <span class="text-danger">*</span></span>
          </div>
          <div class="col-12 col-sm-12 col-md-6 col-lg-6">
            <div class="input-group">
              <input formControlName="duration" class="form-control" type="text" name="duration" data-testId="duration" />
              <div class="input-group-append input-with-inline text-width bg-disabled">
                <span>{{ 'day(s)' | translate }}</span>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="row mt-3" *ngIf="isDirectChannel()">
      <div class="col-12 col-sm-12 col-md-12 col-lg-6">
        <div class="row">
          <div class="col-12 col-sm-12 col-md-4 col-lg-5">
            <span class="font-weight-bold">{{ 'directDiscount' | translate }} <span class="text-danger">*</span></span>
          </div>
          <div class="col-12 col-sm-12 col-md-6 col-lg-6">
            <ng-select
              [items]="directDiscount$ | async"
              bindLabel="directDiscountDesc"
              [placeholder]="'selectOption' | translate"
              formControlName="directDiscount"
              (change)="onDirectDiscountchange()"
              name="directDiscount"
              data-testId="directDiscount"
            >
            </ng-select>
          </div>
        </div>
      </div>
      <div class="col-12 col-sm-12 col-md-12 col-lg-6">
        <div class="row">
          <div class="col-12 col-sm-12 col-md-4 col-lg-5 offset-lg-1">
            <span class="font-weight-bold">{{ 'discount' | translate }}</span>
          </div>
          <div class="col-12 col-sm-12 col-md-6 col-lg-6">
            <div class="input-group">
              <input formControlName="discountRate" class="form-control" type="number" name="discountRate" data-testId="discountRate" />
              <div class="input-group-append input-with-inline percent-width bg-disabled">
                <span>%</span>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </form>
  <div class="btn-submit text-center">
    <button (click)="onSubmit()" type="submit" class="btn btn-app-primary" data-testId="getPriceBtn">
      <span>{{ 'getPriceBtn' | translate }}</span>
    </button>
  </div>
  <div class="main-error-message" *ngIf="isGetPriceError()">
    <span>{{ 'unexpectError' | translate }}</span>
  </div>
</div>
